import CertificateDownloadLink from './CertificateDownloadLink.js';

export default CertificateDownloadLink;
